import styled from 'styled-components'

export const AnnotationsContainer = styled.ol`
  box-sizing: border-box;
  width: 100%;
`
